<template>
    <div class="home">
      <img src="https://p1.ssl.qhimg.com/t110b9a9301afc355d70fb6a02c.png" alt="" />
    </div>
</template>
  
<script setup>
import headerComp from '@/components/common/web-header.vue'
import { ref, onMounted } from 'vue'

onMounted(() => {
})

  </script>
  
  <style lang="scss" scoped>
  .home {
    width: 100%;
    display: flex;
    // background-image: url(https://p5.ssl.qhimg.com/t110b9a9301a18f35a4fe416a4c.png);
    // background-repeat: no-repeat;
    // background-size: cover;
    // background-position: center;
    // width: 100%;
    // height: 440px;
    // position: relative;
    img{
      width: 100%;
    }
  }
  </style>